import PropTypes from 'prop-types';
import _ from 'lodash';
import { Tabs, Tab } from '@mui/material';
import { connect } from 'react-redux';

import localeMessage from '../localeMessage';
import { tabs } from './tabs';

const buttonStyle = {
  borderBottom: '1px solid #dce5f7',
  color: 'rgba(15, 32, 69, 0.75)',
  fontSize: '12px',
  fontWeight: '600',
  letterSpacing: '-0.07em',
  minWidth: 0,
  flex: 1,
};
const activeButtonStyle = {
  ...buttonStyle,
  color: '#2e5fca',
};
const inkBarStyle = { background: '#2e5fca', height: '3px', zIndex: '2' };

export const TabContainer = ({
  activeTab,
  handleChange,
  isCouplesGuest,
  isVonage = false,
  locale,
}) => {
  const filteredTabs = tabs.filter(
    tab =>
      (!isCouplesGuest || tab.name !== 'Notes') &&
      (!tab.vonageOnly || isVonage) &&
      (!tab.hiddenForVonage || !isVonage),
  );

  return (
    <div>
      <Tabs
        value={activeTab}
        onChange={(event, newValue) => handleChange(newValue)}
        slotProps={{ indicator: { style: inkBarStyle } }}
      >
        {_.map(filteredTabs, ({ index, name, inactiveIcon, activeIcon }) => (
          <Tab
            style={activeTab === index ? activeButtonStyle : buttonStyle}
            label={localeMessage(name, locale)}
            key={index}
            value={index}
            icon={activeTab === index ? activeIcon : inactiveIcon}
            disableRipple
          />
        ))}
      </Tabs>
    </div>
  );
};

TabContainer.propTypes = {
  activeTab: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  isCouplesGuest: PropTypes.bool.isRequired,
  isVonage: PropTypes.bool,
  locale: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  return {
    locale: (state.user && state.user.locale) || 'en',
  };
}

export default connect(mapStateToProps)(TabContainer);
